import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/urban people white.png"; // your logo path
import "./Header.css";

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="lg-header">
      <div className="lg-header-inner">
        {/* ✅ Logo only */}
        <div
          className="lg-logo-wrap"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="UrbanGo Logo" className="lg-logo-img" />
        </div>

        {/* ✅ Right-side buttons */}
        <div className="lg-nav-actions">
          <button className="btn-contact" onClick={() => navigate("/organization-register")}>
            Register
          </button>
          <button className="btn-login" onClick={() => navigate("/login")}>
            Login →
          </button>
        </div>
      </div>
    </header>
  );
}
